/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'confluence.project-pages.improvement.provisioning-background.text': 'これは 1 分未満で完了します',
  'confluence.project-pages.improvement.provisioning-background.title': 'プロジェクト ページをセットアップする',
  'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': '閉じる',
  'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': '完了',
  'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': '次へ',
  'project-pages.activating.description':
    '接続された Confluence スペースはまだ準備ができていません。再読み込みしても解決しない場合は、{contactSupport}。',
  'project-pages.activating.heading': 'Confluence はまだ読み込み中です',
  'project-pages.button.connect-different-space-or-page.label': 'スペースまたはページのアイコンを更新',
  'project-pages.button.connect-different-space-or-page.tooltip': '別のスペースまたはページを接続',
  'project-pages.button.connect-space-or-page.tooltip': 'Confluence に接続する',
  'project-pages.button.go-to-connected-page.tooltip': 'Confluence でページを開く',
  'project-pages.button.go-to-connected-space.tooltip': 'Confluence でスペースを開く',
  'project-pages.connect-space-dialog.connection-error': '接続に失敗しました。',
  'project-pages.connect-space-dialog.connection-retry': '再試行',
  'project-pages.connect-space-dialog.content.space-or-page-selector.description':
    'プロジェクトに接続するスペースかページを選択してください。',
  'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Confluence を検索',
  'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description':
    'ページを作成する前に、このプロジェクトをスペースに接続する必要があります。このプロジェクトに接続するスペースを選択してください。',
  'project-pages.connect-space-dialog.error-icon': 'エラー: ',
  'project-pages.connect-space-dialog.footer.cancel': 'キャンセル',
  'project-pages.connect-space-dialog.footer.connect-space': '接続',
  'project-pages.connect-space-or-page-dialog.header.title': 'Confluence にプロジェクトを接続',
  'project-pages.connect-space.description':
    'スペースはフォルダのようなものです。プロジェクトに関連するあらゆるコンテンツの作成、整理、コラボレーションに使用できます。',
  'project-pages.connect-space.not-connected.description':
    'プロジェクト ページを使用するには、管理者またはチーム リードにご依頼のうえ、Confluence をこのプロジェクトに接続してください。',
  'project-pages.connect-space.not-connected.heading': 'Confluence に接続されていません。',
  'project-pages.connect-success-flag.description.content':
    '{connectedSpaceOrPageName} のコンテンツとの接続に成功しました。',
  'project-pages.connection-error.space-or-page-not-found.button': '別のスペースまたはページに接続',
  'project-pages.create-space-dialog.connection-error': '接続に失敗しました。',
  'project-pages.create-space-dialog.connection-retry': '再試行',
  'project-pages.create-space-dialog.content.empty-name': 'スペースに名前を付けてください。',
  'project-pages.create-space-dialog.content.invalid-name': 'スペース名には英数字を 1 字以上使用する必要があります。',
  'project-pages.create-space-dialog.content.placeholder': 'スペース名を入力',
  'project-pages.create-space-dialog.creation-error': 'スペースの作成に失敗しました。',
  'project-pages.create-space-dialog.error-icon': 'エラー: ',
  'project-pages.create-space-dialog.footer.cancel': 'キャンセル',
  'project-pages.create-space-dialog.footer.create-space': '作成',
  'project-pages.create-space-dialog.header.title': '新しい Confluence スペースを作成',
  'project-pages.cross-join.access-revoked.templates.subtitle':
    '管理者が Confluence へのアクセスを拒否したため、プロジェクトページは使用できません。アクセスをリクエストするには、サイト管理者にお問い合わせください。',
  'project-pages.cross-join.access-revoked.templates.title': 'プロジェクト ページを使用する権限がありません',
  'project-pages.cross-join.avatar.view-profile': 'プロフィールを表示',
  'project-pages.cross-join.denied-request.templates.subtitle':
    'サイト管理者が Confluence への参加リクエストを拒否したため、プロジェクト ページを使用できません。',
  'project-pages.cross-join.denied-request.templates.title': '管理者がアクセスを拒否しました',
  'project-pages.cross-join.direct-access.button-subtitle.experimental':
    'Confluence にアクセスできます。サイト管理者はすでにあなたを承認しています。',
  'project-pages.cross-join.errors.unknown-error.description': '再読み込みしても解決しない場合は、{contactSupport}。',
  'project-pages.cross-join.errors.unknown-error.title': '現在プロジェクト ページを表示できません',
  'project-pages.cross-join.inline-join-product.button':
    'Confluence にアクセスできます。サイト管理者はすでにあなたを承認しています。',
  'project-pages.cross-join.inline-join-product.connected.description':
    'ドキュメントを 1 か所から表示、編集、作成します。',
  'project-pages.cross-join.inline-join-product.connected.title': 'プロジェクト ページでチームとコラボレーションする',
  'project-pages.cross-join.pending-request.templates.subtitle':
    'サイト管理者が Confluence への参加リクエストを受け取りました。参加が承認されると、プロジェクト ページが起動し、確認メールが送信されます。',
  'project-pages.cross-join.pending-request.templates.subtitle.experiment':
    '承認されたら、プロジェクト ページにアクセスするためのメールが届きます。',
  'project-pages.cross-join.pending-request.templates.title': 'Confluence へのアクセスをリクエストしました',
  'project-pages.cross-join.pending-request.templates.title.experiment': 'アクセス リクエストが管理者に送信されました',
  'project-pages.cross-join.request-access-without-better-together.connected.description':
    'チームでプロジェクト ドキュメントを表示、編集、作成します。',
  'project-pages.cross-join.request-access.button': 'アクセスをリクエスト',
  'project-pages.cross-join.request-access.button-subtitle.experimental':
    '[チームに参加] を選択すると、Confluence への参加を申請します。これにより、自身のアトラシアン プロファイルを管理者と共有することに同意するものとします。',
  'project-pages.cross-join.request-access.button.experimental': 'チームに参加',
  'project-pages.cross-join.request-access.connected.description.experimental':
    'あなたのチームはプロジェクト ページを使用して、Jira を離れることなくプロジェクト ドキュメントでのコメント作成、編集、コラボレーションを行っています。Confluence に参加して、チームのプロジェクト ページにアクセスしましょう。',
  'project-pages.cross-join.request-access.title': 'プロジェクト ページには Confluence へのアクセスが必要です',
  'project-pages.cross-join.request-access.title.experiment': 'チーム用に信頼できる唯一の情報源を作成する',
  'project-pages.default-contextual-heading': 'プロジェクト ページは Confluence の機能を利用しています。',
  'project-pages.default-contextual-message':
    'Confluence ページを使えば、あらゆるプロジェクト文書の作成、共有、コラボレーションを一か所にまとめることができます。',
  'project-pages.default-reactivate-CTA': 'Confluence を再有効化',
  'project-pages.default-trial-CTA': 'Confluence を無料で 30 日間お試しください',
  'project-pages.draft-saved-flag.action': 'ドラフトを開く',
  'project-pages.draft-saved-flag.description': 'ドラフトは、公開するまで他のユーザーに表示されません。',
  'project-pages.draft-saved-flag.title': 'ドラフトが保存されました',
  'project-pages.embedded-pages.create-page-error.close-button': '閉じる',
  'project-pages.embedded-pages.create-page-error.description': '問題が発生したため、ページを作成できませんでした。',
  'project-pages.embedded-pages.create-page-error.title': 'ページを作成できませんでした。',
  'project-pages.embedded-pages.create-page-error.try-again-button': '再試行',
  'project-pages.embedded-pages.modal.close.button.hint': '閉じる',
  'project-pages.embedded-pages.modal.title.button': 'Confluence で開く',
  'project-pages.embedded-pages.modal.title.button.hint': '新しいタブで開く',
  'project-pages.errors.unknown-error.description.non-final': '再読み込みしても解決しない場合は、{contactSupport}。',
  'project-pages.errors.unknown-error.title.non-final': '現在プロジェクト ページを表示できません',
  'project-pages.generic-error.button.reload': 'ページを更新',
  'project-pages.generic-error.description': '問題が発生しました。しばらくしてからもう一度試してください。',
  'project-pages.generic-error.description.non-final': '問題が発生しました。しばらくしてからもう一度試してください。',
  'project-pages.generic-error.heading': '正常に機能していません。',
  'project-pages.generic-error.title.non-final': '正常に機能していません。',
  'project-pages.generic-info-flag.description':
    '問題が発生しました。もう一度お試しのうえ、問題が解決しない場合はサポートにお問い合わせください。',
  'project-pages.generic-success-flag.description.page': '{connectedSpaceOrPageName} ページと接続しました。',
  'project-pages.generic-success-flag.description.space': '{connectedSpaceOrPageName} スペースと接続しました。',
  'project-pages.generic-success-flag.heading.page': 'ページを接続しました',
  'project-pages.generic-success-flag.heading.space': 'スペースを接続しました',
  'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': 'または新しいスペースを作成',
  'project-pages.granular-pages.connect-space.button': 'Confluence に接続する',
  'project-pages.granular-pages.connect-space.heading': 'このプロジェクトを Confluence スペースまたはページに接続',
  'project-pages.granular-pages.connect-space.heading.non-final':
    'このプロジェクトを Confluence スペースまたはページに接続',
  'project-pages.improvement.contact-support': 'サポートに問い合わせ',
  'project-pages.improvement.errors.access-error.description': 'サイト管理者にアクセス権について問い合わせてください。',
  'project-pages.improvement.errors.access-error.title': 'プロジェクト ページを表示する権限がありません。',
  'project-pages.improvement.errors.page-tree-unknown-error.description':
    '接続された Confluence スペースのページの表示中にエラーが発生しました。再読み込みしても解決しない場合は、{contactSupport}。',
  'project-pages.improvement.errors.page-tree-unknown-error.title': 'プロジェクト ページの表示で問題が発生しています',
  'project-pages.improvement.errors.space-or-page-not-found.description':
    '接続した Confluence スペースまたはページは、移動、アーカイブ、または削除されています。再接続しても問題が解決しない場合は、<link>サポートにお問い合わせください</link>',
  'project-pages.improvement.errors.space-or-page-not-found.title': 'スペースまたはページが見つかりません',
  'project-pages.improvement.errors.unknown-error.description': '再読み込みしても解決しない場合は、{contactSupport}。',
  'project-pages.improvement.errors.unknown-error.title': '現在プロジェクト ページを表示できません',
  'project-pages.improvement.feature1': 'Jira を離れることなくドキュメントにアクセスし、作成する',
  'project-pages.improvement.feature2': 'ミーティングやスプリント計画などのテンプレート',
  'project-pages.improvement.feature3': 'ドキュメントを Jira に同期して自動更新する',
  'project-pages.improvement.heading-info': 'チームの知識を集め、業務の進め方を改善します。',
  'project-pages.improvement.heading-info-v2': 'チームのすべてのプロジェクト ドキュメントをまとめる場所を作成する',
  'project-pages.improvement.learn-more-button': '詳細',
  'project-pages.improvement.powered-by': '使用ソリューション: ',
  'project-pages.improvement.powered-by.tooltip': 'Confluence を新しいタブで開く',
  'project-pages.improvement.preview-teaser': 'テンプレート、プロジェクト ページなどのロックを解除します。',
  'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description':
    '<p>ステータス ラベルを自動更新して、プロジェクト レポートを最新の状態に保ちましょう。</p><p>ドキュメント内で Jira チケットをリンクするだけで、チケットと同期して更新されるステータス ラベルが自動的に表示されます。これにより、時間をかけて手動レポートを作成する必要がなくなります。</p>',
  'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title':
    '関係者にシームレスに最新情報を伝える',
  'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description':
    '<p>組み込みのテンプレートを使用して、一貫性のあるドキュメントを作成しましょう。テンプレートはシンプルで使いやすく、ニーズに合わせてカスタマイズできます。</p><p>テンプレートはプロジェクト ページから直接使用できるので、作業中のページから離れる必要がありません。<a>こちら</a>からすべてのテンプレートを参照できます。</p>',
  'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': 'ドキュメント標準を統合する',
  'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description':
    '<p>Jira の [プロジェクト ページ] タブでドキュメントを作成して重要な情報をまとめ、信頼できる唯一の情報源として運用しましょう。</p><p>プロジェクト ページは Confluence で動作することをご存じでしたか? 最大 10 ユーザーまで無料でご利用になれます。ぜひ管理者設定でチームの他のメンバーを招待してください。</p>',
  'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title':
    'プロジェクト ページを Jira で直接利用',
  'project-pages.improvement.templates.blank-page.description': '最初からページを開始します。',
  'project-pages.improvement.templates.blank-page.name': '白紙ページ',
  'project-pages.improvement.templates.decision.description':
    '重要なプロジェクト決定事項を記録し、それについてチーム内でやり取りできます。',
  'project-pages.improvement.templates.decision.name': '決定事項',
  'project-pages.improvement.templates.meeting-notes.description':
    'ミーティングを計画して議事録やアクション アイテムをチームで共有できます。',
  'project-pages.improvement.templates.meeting-notes.name': 'ミーティング議事録',
  'project-pages.improvement.templates.post-expand.more': 'その他のテンプレート',
  'project-pages.improvement.templates.post-expand.more.tooltip': 'Confluence のすべてのテンプレートを表示',
  'project-pages.improvement.templates.post-expand.subtitle': '人気のテンプレート',
  'project-pages.improvement.templates.post-expand.title': 'ページを作成',
  'project-pages.improvement.templates.pre-expand.more': '他のテンプレートを確認する',
  'project-pages.improvement.templates.pre-expand.subtitle': '似たようなチームに人気のテンプレート',
  'project-pages.improvement.templates.pre-expand.title': 'テンプレートをプレビュー',
  'project-pages.improvement.templates.product-requirements.description':
    '製品や機能の要件の定義、追跡、範囲設定を行います。',
  'project-pages.improvement.templates.product-requirements.name': '製品要件',
  'project-pages.improvement.templates.retrospective.description':
    'どの点がうまくいきましたか?改善点は何ですか?チーム内でのクラウドソーシング利用の改善点を出し合います。',
  'project-pages.improvement.templates.retrospective.name': 'ふりかえり',
  'project-pages.improvement.templates.template.disabled-tooltip': 'まず Confluence スペースを接続します',
  'project-pages.improvement.templates.tutorial.content.confluence-templates':
    '<b>時間を短縮して、手動タスクを削減できます</b>。Confluence には多数のページ <a>テンプレート</a>が用意されているため、最初から作成する手間を省けます。テクニカル ドキュメント、トラブルシューティング ガイド、プロジェクト計画、製品要件などについて考えてみてください。',
  'project-pages.improvement.templates.tutorial.content.edit-and-format':
    '<b>編集や書式設定が簡単にできます</b>。最上部の編集メニューを標準的な書式設定に使用できます。「<b>/</b>」と入力すると多数の便利な統合機能を簡単に挿入できます。「<c>/テーブル</c>」と入力するとテーブルを、「<c>/画像</c>」と入力すると画像を挿入できます。また「<c>/dropbox</c>」で Dropbox のリンクを、「<c>/microsoft</c>」で Microsoft Office ツールを、「<c>/trello</c>」で Trello のボードやカードを挿入できます。',
  'project-pages.improvement.templates.tutorial.content.forward-slash-prompt':
    '「/」の後に「table」または「image」を入力',
  'project-pages.improvement.templates.tutorial.content.getting-started-tips':
    '開始するにあたり役立つヒントをいくつか用意しました。',
  'project-pages.improvement.templates.tutorial.content.handy-links': '便利なリンク',
  'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Jira と Confluence を併用する',
  'project-pages.improvement.templates.tutorial.content.jira-charts':
    '実際の Jira データを使用してページにチャートを作成します。「<c>/Jira charts</c>」と入力します。',
  'project-pages.improvement.templates.tutorial.content.jira-links':
    'ページ上の任意の場所に Jira 課題をリンクします。ページ上のリンクは、Jira 課題を更新するとリアルタイムで更新されます。「<c>/Jira</c>」と入力します。',
  'project-pages.improvement.templates.tutorial.content.jira-roadmaps':
    'Jira プロジェクトによって、インタラクティブなロードマップやタイムラインをページに埋め込みます。「<c>/jira roadmap</c>」と入力します。',
  'project-pages.improvement.templates.tutorial.content.jira-timeline':
    'Jira プロジェクトによって、インタラクティブなタイムラインをページに埋め込みます。「<c>/jira タイムライン</c>」と入力します。',
  'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic':
    'Jira Software をご利用のお客様のうち 76% が、Confluence を追加してからプロジェクトのリリースが早くなったと話しています。',
  'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding':
    'Jira をご利用のお客様のうち 76% が、Confluence を追加してからプロジェクトのリリースが早くなったと話しています',
  'project-pages.improvement.templates.tutorial.content.spaces-and-pages':
    '<b>スペースとページを使用します</b>。スペースはあらゆる Confluence サイトの一部であり、ページをカテゴリに整理する方法でもあります。スペースを別々のフォルダーまたはプロジェクトと考えると、ページはそのフォルダーやプロジェクトに属するドキュメントです。<a>スペースの使用方法に関する詳細についてご確認ください。</a>',
  'project-pages.improvement.templates.tutorial.content.try-it-now': '今すぐ試す',
  'project-pages.improvement.templates.tutorial.description': 'ページの編集方法をご確認ください。',
  'project-pages.improvement.templates.tutorial.name': 'プロジェクト ページにようこそ! ',
  'project-pages.improvement.terms-and-conditions-v2':
    '[今すぐ試す] を選択すると、Confluence への登録を承認し、Atlassian <termsLink>Cloud 利用規約</termsLink>および<privacyLink>プライバシー ポリシー</privacyLink>に同意したことになります。',
  'project-pages.improvement.title': 'プロジェクト ページ',
  'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': 'ページを作成',
  'project-pages.improvement.transient-states.empty-state.auto-provisioned-description':
    'Confluence が追加されたので、すべてのプロジェクト ドキュメントの作成とリンクを開始できます。最大 10 ユーザーまで無料です。',
  'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': '詳細',
  'project-pages.improvement.transient-states.empty-state.create-page-button': '最初のページを作成',
  'project-pages.improvement.transient-states.empty-state.description':
    'ミーティング議事録、製品要件、決定事項やその他のコンテンツを作成して、このスペースを埋めましょう。',
  'project-pages.improvement.transient-states.empty-state.title': 'ここにはまだ、ページがありません。',
  'project-pages.improvement.try-button': 'Confluence でこのテンプレートを試す',
  'project-pages.improvement.try-it-now': '今すぐ試す',
  'project-pages.improvement.try-lozenge': '試す',
  'project-pages.improvement.try-on-demand-button': '無料トライアル',
  'project-pages.page-deleted-flag.title': 'ページが削除されました。',
  'project-pages.page-published-flag.title': 'ページが公開されました。',
  'project-pages.unknown-error.description': '再読み込みしても解決しない場合は、{contactSupport}。',
  'project-pages.unknown-error.heading': '現在プロジェクト ページを表示できません',
  'projectpages.templatepreview.termsandprivacy':
    '[無料で試す] をクリックすると、Atlassian <termsOfServiceLinkText>Cloud 利用規約</termsOfServiceLinkText>と<privacyPolicyLinkText>プライバシー ポリシー</privacyPolicyLinkText>に同意したことになり、Confluence に登録されます。',
};
